import { render, staticRenderFns } from "./Puppy.vue?vue&type=template&id=a98b9fe6&scoped=true"
import script from "./Puppy.vue?vue&type=script&lang=js"
export * from "./Puppy.vue?vue&type=script&lang=js"
import style0 from "./Puppy.vue?vue&type=style&index=0&id=a98b9fe6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98b9fe6",
  null
  
)

export default component.exports